import React, { useState } from 'react';
import { Drawer, List, ListItem, ListItemText } from '@mui/material';
import { useLocation, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './components/LanguageSelector';

const DrawerMenu = ({ toggleDrawer }) => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <>
      <List className="toolbar-menu-list">
        <NavLink to="/" className="nav-link">
          <ListItem
            onClick={() => toggleDrawer(false)}
            className={`toolbar-menu-list-item ${location.pathname === '/' ? 'active' : ''}`}
          >
            <ListItemText primary={t("menu.0")} />
          </ListItem>
        </NavLink>

        <NavLink to="/planning" className="nav-link">
          <ListItem
            onClick={() => toggleDrawer(false)}
            className={`toolbar-menu-list-item ${location.pathname === '/planning' ? 'active' : ''}`}
          >
            <ListItemText primary={t("menu.1")} />
          </ListItem>
        </NavLink>

        <NavLink to="/accommodation" className="nav-link">
          <ListItem
            onClick={() => toggleDrawer(false)}
            className={`toolbar-menu-list-item ${location.pathname === '/accommodation' ? 'active' : ''}`}
          >
            <ListItemText primary={t("menu.2")} />
          </ListItem>
        </NavLink>
      </List>

      <div style={{marginLeft: 'auto', marginRight: '20px', marginTop: '-70px'}}>
        <LanguageSelector />
      </div>
    </>
  );
};


const ToolbarMenu = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (open) => {
    setIsDrawerOpen(open);

    // Synchronize SVG animation
    const svgElement = document.querySelector('.hb');
    if (svgElement) {
      const startEvent = svgElement.querySelector('#start');
      const reverseEvent = svgElement.querySelector('#reverse');
      if (open) {
        startEvent?.beginElement(); // Trigger opening animation
      } else {
        reverseEvent?.beginElement(); // Trigger closing animation
      }
    }
  };

  return (
    <>
      <div
        onClick={() => toggleDrawer(!isDrawerOpen)}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', width: 36, height: 36 }}
      >
        <svg
          className={`hb ${isDrawerOpen ? 'open' : 'close'}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 10 10"
          width="36"
          height="36"
          stroke="#fafafa"
          strokeWidth=".8"
          fill="rgba(0,0,0,0)"
          strokeLinecap="round"
        >
          <path
            className="line"
            d={isDrawerOpen 
              ? "M3,3L5,5L7,3M5,5L5,5M3,7L5,5L7,7" 
              : "M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7"}
          />
          <rect width="10" height="10" stroke="none" />
        </svg>
      </div>

      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => toggleDrawer(false)}
        PaperProps={{
          style: {
            backgroundColor: '#1c1c1c',
            color: '#fafafa'
          },
        }}
      >
        <DrawerMenu toggleDrawer={toggleDrawer} /> {/* Pass toggleDrawer here */}
      </Drawer>
    </>
  );
};

export default ToolbarMenu;